import http from "../http-common";

class Web3AuthService {
  connectWallet(data) {
    return http.post("/api/web3/connect-wallet", data);
  }

  createWallet(data) {
    return http.post("/api/web3/create-wallet", data);
  }

  importWallet(data) {
    return http.post("/api/web3/import-wallet", data);
  }
}

export default new Web3AuthService();

